import {Domain} from '../../../shared/domain/domain.model';
import {DevicePlacement} from '../../../shared/domain/device-placement.model';
export class PublisherBidderAdUnitRequest {
  publisherId: string;
  widgetTypeIds: {[key: string]: DevicePlacement} = {};
  domainIds: string[] = [];
  newDomains: string[] = [];
  prebidVersion: string;

  _domains: Domain[] = [];


}
